<template>
    <div class="container">
        <navigation />

        <div class="row">
            <div class="col-12 text-left">
                <a @click="$router.go(-1)" class="btn btn-link btn-back-link">&laquo; Back</a>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h1>Manage Cards</h1>
            </div>
        </div>

        <div class="row" v-if="cardsFetched">
            <div class="col-12">
                <div class="row member-cards-list">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 member-card-wrapper">
                        <router-link to="/cards/link">
                            <div class="member-card new-card">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="float-left">
                                            <p class="new-card-label">
                                                <strong>Link New Card</strong>
                                            </p>
                                        </div>
                                        <div class="float-right">
                                            <font-awesome-icon :icon="barcodeIcon"></font-awesome-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 member-card-wrapper" v-for="(card, index) in cards" :key="index">
                        <div class="member-card">
                            <div class="row">
                                <div class="col-12">
                                    <div class="float-left">
                                        <p>
                                            <strong>{{ card.retailerName }}</strong><br>
                                            {{ card.cardNumber }}
                                        </p>
                                    </div>

                                    <router-link :to="`/cards/unlink/${card.cardNumber}`" class="btn btn-primary btn-bellstores float-right btn-unlink">
                                        Unlink
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <div class="spinner-wrapper">
                    <font-awesome-icon :icon="spinnerIcon" class="spinner"></font-awesome-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'
import moment from 'moment'
import { faBarcode, faSpinner } from '@fortawesome/free-solid-svg-icons'

export default {
    name: 'ManageCards',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            cards: [],
            errorMessages: [],
            cardsFetched: false
        }
    },
    async mounted () {
        const response = await this.apiService.getCards()
        if (response instanceof APIRequestError || response instanceof APIResponseError) {
            this.errorMessages.push(response.message())
            this.cardsFetched = true
            return
        }

        this.cards = response.cards()
        this.cardsFetched = true
    },
    methods: {
        formatDate (dateStr) {
            return moment(dateStr).format('l')
        }
    },
    computed: {
        barcodeIcon () {
            return faBarcode
        },
        spinnerIcon () {
            return faSpinner
        }
    }
}
</script>

<style scoped lang="scss">
    .spinner-wrapper {
        margin-top: 20px;

        .fa-spinner {
            width: 50px;
            height: 50px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ManageCards.vue